import React from 'react';

export const PageHeader = ({ title, eyebrow, description, actions }) => (
    <div className="flex items-end justify-between border-b pb-5 mb-6"
         style={{ borderColor: 'var(--border-default)' }}>
        <div>
            {eyebrow && (
                <div className="text-[10px] uppercase tracking-[0.15em] font-bold mb-2"
                     style={{ color: 'var(--brand)' }}>
                    {eyebrow}
                </div>
            )}
            <h1 className="font-heading text-2xl sm:text-3xl tracking-tight font-bold">{title}</h1>
            {description && (
                <p className="text-sm mt-2 max-w-2xl" style={{ color: 'var(--text-secondary)' }}>
                    {description}
                </p>
            )}
        </div>
        {actions && <div className="flex gap-2">{actions}</div>}
    </div>
);

export const StatusPill = ({ status, label }) => {
    const map = {
        success: ['#10B981', 'rgba(16, 185, 129, 0.1)'],
        warning: ['#F59E0B', 'rgba(245, 158, 11, 0.1)'],
        error: ['#EF4444', 'rgba(239, 68, 68, 0.1)'],
        info: ['#0EA5E9', 'rgba(14, 165, 233, 0.1)'],
        neutral: ['#94A3B8', 'rgba(148, 163, 184, 0.1)'],
    };
    const [color, bg] = map[status] || map.neutral;
    return (
        <span
            className="inline-flex items-center px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.05em]"
            style={{ color, background: bg, borderRadius: 2 }}
        >
            <span className="status-dot" style={{ background: color }} />
            {label}
        </span>
    );
};

export const Card = ({ title, action, children, className = '', testId }) => (
    <div
        data-testid={testId}
        className={`border ${className}`}
        style={{ background: 'var(--bg-surface)', borderColor: 'var(--border-default)', borderRadius: 2 }}
    >
        {(title || action) && (
            <div className="px-5 py-3 flex items-center justify-between border-b"
                 style={{ borderColor: 'var(--border-default)' }}>
                <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.05em]">{title}</h3>
                {action}
            </div>
        )}
        <div className="p-5">{children}</div>
    </div>
);

export const Stat = ({ label, value, suffix, status, testId }) => (
    <div
        data-testid={testId}
        className="border p-4"
        style={{ background: 'var(--bg-surface)', borderColor: 'var(--border-default)', borderRadius: 2 }}
    >
        <div className="text-[10px] uppercase tracking-[0.15em] font-bold"
             style={{ color: 'var(--text-secondary)' }}>
            {label}
        </div>
        <div className="mt-2 flex items-baseline gap-2">
            <div className="font-mono text-2xl font-bold tracking-tight">{value}</div>
            {suffix && <div className="text-xs font-mono"
                            style={{ color: 'var(--text-secondary)' }}>{suffix}</div>}
        </div>
        {status && <div className="mt-2">{status}</div>}
    </div>
);
